import Echo from 'laravel-echo';
import Pusher from 'pusher-js';

import Swiper from 'swiper';
import {Navigation, Pagination} from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';
const swiperBase = Swiper;
swiperBase.use([Navigation, Pagination])

window.Swiper = swiperBase;

window.Pusher = Pusher;

window.Echo = new Echo({
    broadcaster: 'pusher',
    key: process.env.MIX_PUSHER_APP_KEY,
    cluster: process.env.MIX_PUSHER_APP_CLUSTER,
    forceTLS: true
});

import Quill from '../../node_modules/quill/dist/quill';
window.Quill = Quill;

import Alpine from 'alpinejs';
import collapse from '@alpinejs/collapse';
import Mask from '@alpinejs/mask';
import persist from '@alpinejs/persist'
import intersect from '@alpinejs/intersect'
import Tooltip from "@ryangjchandler/alpine-tooltip";
import Focus from '@alpinejs/focus';
import AlpineFloatingUI from '@awcodes/alpine-floating-ui';
import NotificationsAlpinePlugin from '../../vendor/filament/notifications/dist/module.esm'

Alpine.plugin(Focus);
Alpine.plugin(Mask);
Alpine.plugin(AlpineFloatingUI);
Alpine.plugin(Tooltip);
Alpine.plugin(intersect)
Alpine.plugin(collapse);
Alpine.plugin(NotificationsAlpinePlugin)

Alpine.plugin(persist);

window.Alpine = Alpine;

Alpine.store('darkMode', {
    on: Alpine.$persist(false).as("darkMode_on"),

    toggle() {
        this.on = ! this.on
    }
})

Alpine.store('menuSidebar', {
    open: Alpine.$persist(false).as("menuSidebar_open"),

    toggle() {
        this.open = ! this.open;
        window.dispatchEvent(new Event('menu-sidebar-toggled'));
    }
})



Alpine.start();



